export default "__VITE_ASSET__CfnReECw__"